import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeMovie, FetMovieDetail, FetBrowserMovies, removeBrowse } from "../Redux/action";
import { Col, Row } from 'react-bootstrap';
import { mock } from './mock';
import MovieItem from './../Home/movie_item';
import MoviesItemSkeletion from '../Home/moviesItemSkeletion';
import MovieHelmet from './../SEO/MovieHelmet';
const BrowserMovies = () => {
    const browseMoviesList = useSelector(state => state.fetbrowseMovies);
    const data = browseMoviesList.browserMovies
    const dispatch = useDispatch();
    const searchRef = useRef(null);
    const qualityRef = useRef();
    const gerneRef = useRef();
    const ratingRef = useRef();
    const yearRef = useRef();
    const languageRef = useRef();
    const orderRef = useRef();
    const [searchterm, setSearchterm] = useState('')
    const [quality, setquality] = useState('');
    const [gerne, setgerne] = useState('');
    const [rating, setrating] = useState('');
    const [year, setyear] = useState('');
    const [language, setlanguage] = useState('');
    const [orderby, setorderby] = useState('')
    const IndexSt = Array.from({ length: 20 });
    const summitHandle = (e) => {
        e.preventDefault();
        setSearchterm(searchRef.current.value)
        setquality(qualityRef.current.value);
        setgerne(gerneRef.current.value);
        setrating(ratingRef.current.value);
        setyear(yearRef.current.value);
        setlanguage(languageRef.current.value);
        setorderby(orderRef.current.value);
    }
    useEffect(() => {
        dispatch(FetMovieDetail());
        dispatch(FetBrowserMovies(searchterm, quality, gerne, rating, year, language, orderby));
        return () => {
            dispatch(removeMovie());
            dispatch(removeBrowse());
        }
    }, [dispatch, searchterm, quality, gerne, rating, language, orderby, year])
    let title = "Browse Movies"
    return (
        <div className="container mt-5 browser-page">
            <MovieHelmet title={title} discripction={title} />
            <div className="p-2">
                <Row>
                    <Col xs={12} md={12}>
                        <div className="row justify-content-center">
                            <div className="card card-sm bg-light-theme rounded">
                                <div className="card-body row no-gutters align-items-center">
                                    <div className="col">
                                        <input ref={searchRef} className="form-control form-control-lg rounded-pill bg-transparent" type="search" placeholder="Search Movies" />
                                    </div>
                                    <div className="col-auto">
                                        <button onClick={summitHandle} className="btn btn-lg btn-warning rounded-pill"> <i className="bi bi-search h4 " /> Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Row className="bg-light-theme rounded mt-3 p-2">
                            <Col>
                                <div className="mb-3">
                                    <label className="form-label">Quality:</label>
                                    <select ref={qualityRef} className="form-select form-control-lg rounded-pill bg-light-theme">
                                        <option defaultValue value="">All</option>
                                        {
                                            mock.Quality?.map(quality => {
                                                return <option key={quality.id} value={quality.value}>{quality.value}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </Col>
                            <Col>
                                <div className="mb-3">
                                    <label className="form-label">Genre:</label>
                                    <select ref={gerneRef} className="form-select form-control-lg rounded-pill bg-light-theme">
                                        <option defaultValue value="">All</option>
                                        {
                                            mock.Genre?.map(Genre => {
                                                return <option key={Genre.id} value={Genre.value}>{Genre.value}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </Col>
                            <Col>
                                <div className="mb-3">
                                    <label className="form-label">Rating:</label>
                                    <select ref={ratingRef} className="form-select form-control-lg rounded-pill bg-light-theme">
                                        <option defaultValue value="">All</option>
                                        {
                                            mock.Rating?.map(rating => {
                                                return <option key={rating.id} value={rating.value}>{rating.value + '+'}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </Col>
                            {/* <Col>
                                <div className="mb-3">
                                    <label className="form-label">Year:</label>
                                    <select ref={yearRef} className="form-select form-control-lg rounded-pill bg-light-theme">
                                        <option selected value="">All</option>
                                        {
                                            mock.Year?.map(year => {
                                                return <option key={year.id} value={year.value}>{year.value}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </Col>
                            <Col>
                                <div className="mb-3">
                                    <label className="form-label">Language:</label>
                                    <select ref={languageRef} className="form-select form-control-lg rounded-pill bg-light-theme">
                                        <option selected value="">All</option>
                                        {
                                            mock.Language?.map(Language => {
                                                return <option key={Language.id} value={Language.value}>{Language.title}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </Col>
                            <Col>
                                <div className="mb-3">
                                    <label className="form-label">Order By:</label>
                                    <select ref={orderRef} className="form-select form-control-lg rounded-pill bg-light-theme">
                                        <option selected value="">All</option>
                                        {
                                            mock.OrderBy?.map(OrderBy => {
                                                return <option key={OrderBy.id} value={OrderBy.value}>{OrderBy.value}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </Col> */}
                        </Row>
                    </Col>
                </Row>
                <div className="container-card mt-3">
                    {!browseMoviesList.LoadingBrowse ?
                        <Row className="bg-light-theme rounded pt-2 pb-3">
                            {
                                data && data.map((Movies, index) => {
                                    return (
                                        <Col xs={6} md={2} key={index} className="px-2">
                                            <div className="item">
                                                <MovieItem {...Movies} />
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                            {
                                data === undefined && <div className="text-center">
                                    <img className="img-fluid w-50" src={process.env.PUBLIC_URL + "/no-file.png"} alt="No Movies" />
                                    <h2>Not Found Movies</h2>
                                </div>
                            }

                        </Row> :
                        <Row className="bg-light-theme rounded pt-2 pb-3">
                            {
                                IndexSt?.map((index) => {
                                    return (
                                        <Col xs={6} md={2} key={index}>
                                            <MoviesItemSkeletion />
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    }

                </div>
            </div>
        </div>
    );
}
export default BrowserMovies;